<template>
  <ul class="winners-2021-place-winners-card-winners-list">
    <li
      class="winners-2021-place-winners-card-winners-list__li"
      v-for="(winner, index) in winners"
      :key="index"
    >
      <Winners2021WinnerItem
        class="winners-2021-place-winners-card-winners-list__winner"
        :user="winner"
      />
    </li>
  </ul>
</template>

<script>
import Winners2021WinnerItem from "./Winners2021WinnerItem";

export default {
  name: "Winners2021PlaceWinnersCardWinnersList",
  components: {
    Winners2021WinnerItem
  },
  props: {
    winners: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss">
.winners-2021-place-winners-card-winners-list {
  list-style: none;
  margin: -10px;
  width: calc(100% + 20px);
  margin-bottom: 15px;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  &__winner {
    width: 100%;
    max-width: 100%;
  }

  &__li {
    padding: 10px;
    width: 50%;
  }

  @include breakpoint("sm-and-down") {
    padding: 5px;
    &:first-child {
      margin-right: 0;
    }
  }

  @include breakpoint("xs-only") {
    &__li {
      width: 100%;
    }
  }
}
</style>
